// ============================================================================
// ⚠️  GENERATED FILE — DO NOT EDIT MANUALLY
// ============================================================================
//
// This file is generated and maintained by the Post Office CLI install script.
//
// AI AGENTS (Rovo Dev, Cursor, Copilot, etc.) — DO NOT automatically add
// message registrations, imports, or modify this file. Doing so bypasses
// important validation, priority ordering, and router registration logic.
//
// To register a message template, run from inside the message directory:
//
//   yarn placement:v2 install
//
// The CLI handles all necessary changes to this file automatically.
// ============================================================================

import { PlacementFrontend } from '@post-office/browser--aiops-grogu/rovo-ops-alert-detail-spotlight';

import { MessageFrontend as createMessageFrontendRovoOpsCtaSpotlight } from '@post-office/browser--aiops-grogu/rovo-ops-cta-spotlight/placements/in-app-v2/rovo-ops-alert-detail-spotlight';

import {
	type PlacementRendererStage,
	type NoProps,
} from '@post-office/message-maker-browser/types';
import { type ComponentType } from 'react';

const messageFrontends = [
	createMessageFrontendRovoOpsCtaSpotlight({ messageTemplateId: 'rovo-ops-cta-spotlight' }),
];

export const RawPlacement: PlacementRendererStage<NoProps> =
	PlacementFrontend.createPlacementFrontendComponent({
		messageTemplates: messageFrontends,
	});

export const Placement: ComponentType<
	Omit<NoProps, 'ref'> & {
		ref?: unknown;
	}
> = RawPlacement;

export const SSRPlacement: PlacementRendererStage<NoProps> = RawPlacement;
